import {unavailableIntents} from 'src/shared/constants/scheduleCallbackIntents';
import {selectTimeslotStep} from 'src/pages/scheduleCallback/store/actions/selectTimeslotStep';
import {intent} from 'src/pages/scheduleCallback/store/selectors/app';
import {unavailableStep} from 'src/pages/scheduleCallback/store/actions/unavailableStep';

export const submitIntent = () => (dispatch, getState) => {
  const currentIntent = intent(getState());

  if (unavailableIntents.includes(currentIntent)) {
    return dispatch(unavailableStep());
  }

  return dispatch(selectTimeslotStep());
};
